document.addEventListener("DOMContentLoaded", function () {
    // Inicializar WaveSurfer para el audio principal
    const wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "WHITE",
        progressColor: "#ffd700",
        cursorColor: "transparent",
        barWidth: 2,
        responsive: true,
        height: 80,
        backend: 'MediaElement',
        preload: 'auto'
    });

    // Cargar el archivo principal
    wavesurfer.load("https://cdn.shopify.com/s/files/1/0681/9879/3286/files/mashup_bundle.mp3?v=1759002709");

    // Botón de Play/Pause para el audio principal
    const playPauseBtn = document.getElementById("playPauseBtn");
    playPauseBtn.addEventListener("click", () => {
        if (wavesurfer.isPlaying()) {
            wavesurfer.pause();
            playPauseBtn.textContent = "▶";
        } else {
            wavesurfer.play();
            playPauseBtn.textContent = "⏸";
        }
    });

    // Lista de todas las muestras de audio
    const samples = [
        { id: "waveform1", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_808_Crushing_2_Spinz_C.wav?v=1758945750" }, { id: "waveform2", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Snare_Virrey.mp3?v=1758945749" },
        { id: "waveform3", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/drum_kit_muestra_1.mp3?v=1758999695" }, { id: "waveform4", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/drum_kit_muestra_2.mp3?v=1758999934" },
        { id: "waveform5", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Baron_-_148_BPM_E_Min.mp3?v=1758945750" }, { id: "waveform6", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_King_-_140_BPM_F_Min.mp3?v=1758945750" },
        { id: "waveform7", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Monarch_-_145_BPM_E_Min.mp3?v=1758945750" }, { id: "waveform8", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Princess_-_135_BPM_C_Min.mp3?v=1758945750" },
        { id: "waveform9", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_REESE_Page_C.mp3?v=1758945750" }, { id: "waveform10", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_REESE_Ambassador_C.mp3?v=1758945750" },
        { id: "waveform11", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_BASS_Empire_C.mp3?v=1758945749" }, { id: "waveform12", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_DONK_Brocade_C.mp3?v=1758945749" },
        { id: "waveform13", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Etiquete_MIDI_-_D_Harmonic_Min.mp3?v=1758945750" }, { id: "waveform14", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Dynasty_MIDI_-_C_Harmonic_Min.mp3?v=1758945749" },
        { id: "waveform15", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Blueblood_MIDI_-_E_Harmonic_Min.mp3?v=1758945750" }, { id: "waveform16", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/Sonnity_-_Ballroom_MIDI_-_D_Harmonic_Min.mp3?v=1758945749" },
        { id: "waveform17", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/BEAT_FINAL_CURSO_course.mp3?v=1759001034" }, { id: "waveform18", file: "https://cdn.shopify.com/s/files/1/0681/9879/3286/files/SAMPLING_DRILL_course.mp3?v=1759000919" },
        { id: "waveform19", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/sounplace_-_DRUM_LOOP_7_-_140_BPM_F_Min.wav?v=1762026362" }, { id: "waveform20", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/sounplace_-_DRUM_LOOP_2_-_100_BPM_A_Min.wav?v=1762026362" },
        { id: "waveform21", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/sounplace_-_DRUM_LOOP_4_-_150_BPM_F_Min.wav?v=1762026362" }, { id: "waveform22", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/sounplace_-_DRUM_LOOP_6_-_140_BPM_E_Min.wav?v=1762026362" }
    ];

    let wavesurfers = {};

    // 🔄 Inicializar las muestras en lotes
    let currentIndex = 0;
    const batchSize = 4; // Puedes ajustar si quieres 6, 8, etc.
    const loadDelay = 300; // Milisegundos entre cada lote

    function loadNextBatch() {
        const batch = samples.slice(currentIndex, currentIndex + batchSize);
        batch.forEach(sample => {
            wavesurfers[sample.id] = WaveSurfer.create({
                container: `#${sample.id}`,
                waveColor: "white",
                progressColor: "#ffd700",
                cursorColor: "transparent",
                barWidth: 2,
                responsive: true,
                height: 40,
                backend: 'MediaElement',
                preload: 'auto'
            });

            wavesurfers[sample.id].load(sample.file);
        });

        currentIndex += batchSize;

        if (currentIndex < samples.length) {
            setTimeout(loadNextBatch, loadDelay);
        }
    }

    loadNextBatch(); // Iniciar carga por lotes

    // Botones de reproducción para cada muestra de audio
    document.querySelectorAll(".play-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const waveformId = this.nextElementSibling.id;
            if (wavesurfers[waveformId].isPlaying()) {
                wavesurfers[waveformId].pause();
                this.textContent = "▶";
            } else {
                // Pausar todas las demás muestras antes de reproducir una nueva
                Object.keys(wavesurfers).forEach(id => wavesurfers[id].pause());
                document.querySelectorAll(".play-btn").forEach(b => (b.textContent = "▶"));

                wavesurfers[waveformId].play();
                this.textContent = "⏸";
            }
        });
    });

    // Función para preguntas frecuentes (FAQ)
    document.querySelectorAll(".faq-question").forEach(btn => {
        btn.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const toggleSign = this.querySelector(".faq-toggle");

            if (answer.style.maxHeight) {
                answer.style.maxHeight = null;
                answer.style.opacity = "0";
                toggleSign.textContent = "+";
            } else {
                document.querySelectorAll(".faq-answer").forEach(ans => {
                    ans.style.maxHeight = null;
                    ans.style.opacity = "0";
                });
                document.querySelectorAll(".faq-toggle").forEach(sign => (sign.textContent = "+"));

                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.opacity = "1";
                toggleSign.textContent = "-";
            }
        });
    });
});
